import { render, staticRenderFns } from "./GJgrowEventCreateExamineeSettingSchoolClasses.vue?vue&type=template&id=6e8734a6&scoped=true&"
import script from "./GJgrowEventCreateExamineeSettingSchoolClasses.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateExamineeSettingSchoolClasses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8734a6",
  null
  
)

export default component.exports